import React from 'react';
import { Form } from 'antd';
import { UploadDocumentsBox } from '@/components';
import ZoomImage from '@/components/investorComponents/ZoomImage';
import { entitiesActions } from '@/store/entities';
import { useDispatch } from 'react-redux';

const imageTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/svg+xml'];

export const ProductImageUpload = ({ productId, image, setImage, logoURL, t }) => {
  const dispatch = useDispatch();
  if (!productId) return null;

  return (
    <>
      <Form.Item label={t('Product image')}>
        <UploadDocumentsBox
          docs={image ? [image] : null}
          setDocs={(newImage) => {
            const img = newImage ?? null;
            if (newImage) {
              const MAX_FILE_SIZE = 10 * 1024 * 1024;
              if (img?.size > MAX_FILE_SIZE) {
                dispatch(
                  entitiesActions.addToastError(t('File is too large. Maximum size is 10MB.'))
                );
                return false;
              } else if (!imageTypes.includes(img?.type)) {
                dispatch(
                  entitiesActions.addToastError(t('Available image types are PNG, JPG, WEBP, SVG.'))
                );
                return false;
              }
            }

            setImage(img);
          }}
          buttonProps={{
            label: t('Upload image')
          }}
        />
      </Form.Item>
      {logoURL && <ZoomImage image={logoURL} />}
    </>
  );
};
